import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset scroll position to top on every route change
    // "auto" is the browser-standard and future-safe behavior
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]); // Runs whenever the route path changes

  return null; // This component does not render anything
}
